module.exports = __webpack_public_path__ + "img/sm.494ff576.svg";